<template>
  <div class="multi-select-dropdown">
    <div class="tag-container">
      <span class="selected-users">Selected users count: 
        <span class="count">{{ selectedUsers.length }}</span>
      </span>

      <button type="button" class="btn btn-light clear-selection" @click="clearSelection">Clear</button>
      <span class="toggle" @click="isOpen = !isOpen">▾</span>
    </div>

    <div v-if="isOpen" class="dropdown">
      <input 
        v-model="searchQuery"
        type="text" 
        class="search-input" 
        placeholder="Search users"
        :disabled="loading"
        @input="onSearchInput" />

      <div v-if="loading">Loading...</div>
      <div v-else>
        <div 
          v-for="(user, index) in filteredUsers"
          :key="index"  
          class="dropdown-item"
          @click="toggleSelection(user)"
          >
          <input
            type="checkbox"
            :checked="selectedUsers.includes(user.name)"
            readonly
          />
          <span >{{ user.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from "@/helpers/constants";

export default {
  name: 'UserMultiSelectDropdown',
  data() {
    return {
      allUsers: [],
      selectedUsers: [],
      selectedUsersids:[],
      searchQuery: '',
      isOpen: true,
      loading: false,
      debounceTimer: null,
      selectedSection: -1,
      selectedPlatoon: -1,
    };
  },
  computed: {
    filteredUsers() {
      return this.allUsers;
    }
  },
    mounted() {
    this.getUserList();
  },
  methods: {
    onSearchInput() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.getUserList();
      }, 300);
    },
    toggleSelection(user) {
      const index = this.selectedUsers.indexOf(user.name);
      if (index === -1) {
        this.selectedUsers.push(user.name);
        this.selectedUsersids.push(user.udid);
      } else {
        this.selectedUsers.splice(index, 1);
        this.selectedUsersids.splice(index, 1);
      }
      this.$emit('update-selected-users', this.selectedUsersids);
    },
    getUserList() {
      this.loading = true;
      this.$store
        .dispatch("user/list", {
          page: Constants.DEFAULT_PAGE,
          page_size: Constants.DEFAULT_PAGE_SIZE,
          sort: 'name',
          order: "asc",
          section_id: this.selectedSection || -1,
          search_term: this.searchQuery,
          platoon_id: this.selectedPlatoon || -1,
        })
        .then((data) => {
          const { rows } = data.data;
          this.allUsers = rows;
          this.loading = false;
        }).catch((err) => {
          this.loading = false;
          console.error("Error fetching user list: ", err);
          this.$snackbar.add({
            type: "error",
            text: "Failed to fetch user list.",
          });
        });
    },
    clearSelection() {
      this.selectedUsers = [];
      this.selectedUsersids = [];
      this.searchQuery = '';
      this.$emit('update-selected-users', []);
    }
  },
};
</script>

<style scoped>
/* Reuse same styles */
.multi-select-dropdown {
  border: 1px solid #ccc;
  font-family: 'Segoe UI', sans-serif;
  border-radius: 5px;
  margin-bottom: 1rem;
}

.tag-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  padding: 6px;
}

.tag {
  background: #e6e6e6;
  border-radius: 3px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
}

.remove-tag {
  margin-left: 4px;
  cursor: pointer;
}

.count {
  background-color: #4f46e5;
  color: white;
  padding: 3px 8px;
  border-radius: 50%;
  font-weight: bold;
  margin-left: auto;
}

.selected-users {
    width: 60%;
    font-size: 1rem;
    font-weight: 700;
}

.clear-selection {
    width: 25%;
    margin-bottom: 0 !important;
}

.toggle {
  width: 5%;
  cursor: pointer;
  padding-left: 1rem;
}

.dropdown {
  max-height: 250px;
  overflow-y: auto;
  border-top: 1px solid #ccc;
  padding: 8px;
  padding-left: 0.5rem;
}

.search-input {
  width: 100%;
  padding: 6px;
  margin-bottom: 8px;
  border: 1px solid #ccc;
  border-radius: 3px;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 2px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #7aacaa;
}
</style>
